import type { TextElement } from '@tencent/alloy-editor';
import { STHyperlinkColor } from '@tencent/slide-sdk-model';

function getLinkColorType(textElement?: TextElement) {
    if (!textElement) {
        return;
    }
    return textElement['origin-href']?.colorType;
}

/**
 * 根据 textElement 判断是否要显示填充颜色
 * @param textElement
 * @returns
 */
export function isShowTextFill(textElement?: TextElement): boolean {
    // 不是链接就显示填充
    if (!isLinkText(textElement)) {
        return true;
    }
    // 是链接且 colorType 为 tx 才显示填充
    return getLinkColorType(textElement) === STHyperlinkColor[2];
}

/**
 * 根据 textElement 判断是否是链接
 * @param textElement
 * @returns
 */
export function isLinkText(textElement: TextElement | void): boolean {
    if (!textElement) {
        return false;
    }
    return !!textElement['origin-href'];
}
